export default "__VITE_ASSET__lF5EZtww__"